module.exports = __webpack_public_path__ + "static/media/editing-page2.05d78cf1.png";